/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-15 16:25:05
 * @modify date 2020-04-15 16:25:05
 * @desc [description]
 */
import axios from 'axios';

/**
 * getUserNewNotificationsCount get api
 * to get the new notifications count */
export async function getUserNewNotificationsCount() {
  let result = {};
  await axios.get(`${process.env.VUE_APP_JAVA_API_URL}/user_notification_count`).then((response) => {
    if (response.status === 200) {
      result = response.data;
    }
  }).catch((err) => {
    console.log('get user_notification_count java api error', err); // eslint-disable-line no-console
  });
  return result;
}
/**
 * registration_notifications post api
 * to get the notification based on selected dates */
export async function getUserNotificationsAlert(alertObj) {
  let notifications = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/registration_notifications`, alertObj)
    .then((response) => {
      if (response.status === 200) {
        notifications = response.data;
      }
    })
    .catch((err) => {
      console.log('post registration_notifications java api error', err); // eslint-disable-line no-console
    });
  return notifications;
}

/**
 * general_notifications post api
 * to get the General notification based on selected dates */
export async function getUserGeneralNotificationsAlert(alertObj) {
  let notifications = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/general_notifications`, alertObj)
    .then((response) => {
      if (response.status === 200) {
        notifications = response.data;
      }
    })
    .catch((err) => {
      console.log('post general_notifications java api error', err); // eslint-disable-line no-console
    });
  return notifications;
}
/**
 * get_all_service_counts post api
 * to get the notification count based on selected dates for active services */
export async function getAllActiveServiceCounts(requestObj) {
  let notificationCounts = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/get_all_service_counts`, requestObj)
    .then((response) => {
      if (response.status === 200) {
        notificationCounts = response.data;
      }
    })
    .catch((err) => {
      console.log('post get_all_service_counts java api error', err); // eslint-disable-line no-console
    });
  return notificationCounts;
}

export async function dismissExpiryBannerUsingPOST(payLoad) {
  let expiryData = [];
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/market/place/expiry/banner/dismiss`, payLoad)
    .then((response) => {
      if (response.status_code === 200) {
        expiryData = response.data;
      }
    })
    .catch((err) => {
      console.log('get expirydata java api error', err); // eslint-disable-line no-console
    });
  return expiryData;
}
